/**
 * Persisted CCP network-drop domain state.
 * Read / write / clear only — reconcile logic lives in streamsStore.
 */

export const CCP_NETWORK_DROP_KEY = 'ccp_network_drop';

export type NetworkDropPhase = 'idle' | 'armed' | 'timedOut';

export interface NetworkDropState {
  phase: NetworkDropPhase;
  startedAt: number | null;
  fromReload: boolean;
  callHeaderId: string | null;
  contactId: string | null;
}

export const IDLE_NETWORK_DROP_STATE: NetworkDropState = {
  phase: 'idle',
  startedAt: null,
  fromReload: false,
  callHeaderId: null,
  contactId: null,
};

function isPhase(value: unknown): value is NetworkDropPhase {
  return value === 'idle' || value === 'armed' || value === 'timedOut';
}

export function readNetworkDropState(): NetworkDropState {
  try {
    const raw = localStorage.getItem(CCP_NETWORK_DROP_KEY);
    if (!raw) return { ...IDLE_NETWORK_DROP_STATE };
    const parsed = JSON.parse(raw) as Partial<NetworkDropState>;
    if (!isPhase(parsed.phase)) return { ...IDLE_NETWORK_DROP_STATE };
    return {
      phase: parsed.phase,
      startedAt: typeof parsed.startedAt === 'number' ? parsed.startedAt : null,
      fromReload: Boolean(parsed.fromReload),
      callHeaderId:
        parsed.callHeaderId == null ? null : String(parsed.callHeaderId),
      contactId: parsed.contactId == null ? null : String(parsed.contactId),
    };
  } catch {
    return { ...IDLE_NETWORK_DROP_STATE };
  }
}

export function writeNetworkDropState(state: NetworkDropState): void {
  if (state.phase === 'idle') {
    localStorage.removeItem(CCP_NETWORK_DROP_KEY);
    return;
  }
  localStorage.setItem(CCP_NETWORK_DROP_KEY, JSON.stringify(state));
}

export function clearNetworkDropState(): void {
  localStorage.removeItem(CCP_NETWORK_DROP_KEY);
}
